module.exports = __webpack_public_path__ + "img/login.42f4ba68.png";